"use client";
import React, { useEffect, useState } from "react";
// import { Section } from "@/types/common";
import { TrendingCard } from "@/components/Card/TrendingCard";
import SectionHeading from "@/components/SectionHeading/SectionHeading";
// import { useParams } from "next/navigation";
import { articleService } from "@/services/articleService";
// import { articleData } from "@/services/dummay";
import { Button } from "./ui/Button";

const ListingSection = ({
  hideBrandLogo,
  type,
  usedPostIds,
  setUsedPostIds,
  slug,
  post_type,
  brandId,
  initialArticles = [],
  initialLoaded = false,
  lineheight,
}: {
  hideBrandLogo?: boolean;
  type: string;
  usedPostIds: number[];
  setUsedPostIds: (postIds: number[]) => void;
  slug: string;
  post_type: string;
  brandId: number;
  initialArticles?: any[];
  initialLoaded?: boolean;
  lineheight?: string;
}) => {
  const [viewMore, setViewMore] = useState(false);
  const [articles, setArticles] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(2);
  const [loading, setLoading] = useState(!initialLoaded);

  useEffect(() => {
    if (initialLoaded) {
      setArticles(initialArticles);
      setLoading(false);
      if (initialArticles.length === 0) {
        setViewMore(false);
      }
    }
  }, [initialLoaded, initialArticles]);

  const handleViewMore = async () => {
    try {
      setLoading(true);
      const querySlug =
        slug +
        `?post_type=${post_type}&page_size=5&page_number=${currentPage}&brandId=${brandId}&mode=${type}&usedPostIds=${usedPostIds.join(",")}`;

      const response = await articleService.getSuggestedArticles(querySlug);
      const newArticles =
        type === "trending"
          ? response?.data?.trending || []
          : response?.data?.related || [];

      setArticles((prev) => [...prev, ...newArticles]);
      setCurrentPage((prev) => prev + 1);
      setUsedPostIds([
        ...usedPostIds,
        ...newArticles.map((article: any) => article.post_id),
      ]);
      if (newArticles.length === 0) {
        setViewMore(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lg:px-0">
      {/* {JSON.stringify(usedPostIds)} */}
      {!initialLoaded && loading ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : articles && articles?.length > 0 ? (
        <>
          <div className="flex flex-col gap-4">
            <SectionHeading link={type || ""} title={type || ""} />
          </div>
          <div className="grid grid-cols-1 gap-2 lg:gap-4">
            {articles.map((article, index) => (
              <TrendingCard
                key={`article-${article.title}-${index}`}
                data={article}
                hoverStyle="default"
                imageSize="xlarge"
                imageStyle={"rounded"}
                layout={"horizontal"}
                wantDescription={false}
                titleSize="medium"
                description="small"
                className="lg:w-20 lg:h-20 w-16 h-16"
                descriptionSize="small"
                isVideo={article.isVideo?.toString()}
                title="normal"
                hideBrandLogo={hideBrandLogo}
                lineheight={lineheight}
              />
            ))}
          </div>
          {viewMore && (
            <div className="flex justify-start">
              <Button
                size="sm"
                onClick={() => handleViewMore()}
                disabled={loading}
              >
                {loading ? "LOADING..." : "+ VIEW MORE"}
              </Button>
            </div>
          )}
        </>
      ) : !initialLoaded ? null : (
        <p className="text-center text-gray-500">No articles available.</p>
      )}
    </div>
  );
};

export default ListingSection;
